module.exports = __webpack_public_path__ + "static/media/Nov_2025_4.a8649d0b.webp";